import { type FC } from 'react'
import { Helmet, HelmetProvider } from 'react-helmet-async'

export interface HeadersProps {
  title: string
}

export const Headers: FC<HeadersProps> = ({ title }) => {
  return (
    <HelmetProvider>
      <Helmet>
        <title>{title}</title>
        <meta
          name="description"
          content="Evergreen Wealth is a comprehensive advisory service that is a technology-driven, human-advised, and tax efficient way to manage all your money."
        />

        {/* Open Graph */}
        <meta property="og:title" content="Evergreen Wealth" />
        <meta
          property="og:description"
          content="Evergreen Wealth is a comprehensive advisory service that is a technology-driven, human-advised, and tax efficient way to manage all your money."
        />
        <meta property="og:url" content="https://evergreenwealth.com" />
        <meta property="og:type" content="website" />
        <meta property="og:image" content="/evergreen-wealth.png" />

        {/* Twitter  */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="Evergreen Wealth" />
        <meta
          name="twitter:description"
          content="Evergreen Wealth is a comprehensive advisory service that is a technology-driven, human-advised, and tax efficient way to manage all your money."
        />
        <meta name="twitter:image" content="/evergreen-wealth.png" />
        <meta name="twitter:url" content="https://evergreenwealth.com" />
      </Helmet>
    </HelmetProvider>
  )
}
